import api from '../api';

const getAccount = config => api.get('/api/account/', config);

const userEdit = userData =>
  api.post(`/api/members/${userData.id}`, {
    ...userData,
  });

export default { getAccount, userEdit };
